import Swal from 'sweetalert2';
import { useAuthContext } from '../../../../../../contexts/authContext';
import variables from '../../../../../../shared/styles/settings.module.scss';
import { asyncDeleteAttachmentChatAssistant } from '../../../../../../services/chat-assistant.service';

export const useAttachmentActions = (
    onDelete: (id: string | number) => void
) => {
    const { modeTheme } = useAuthContext();
    const iconColor =
        modeTheme === 'darkMode' ? variables.darkColor : variables.primaryColor;

    const handleDelete = (id: string | number) => {
        if (!Boolean(id?.toString()?.trim())) return;
        Swal.fire({
            title: 'Eliminar',
            text: '¿Está seguro que desea eliminar el archivo?',
            icon: 'question',
            iconColor,
            showDenyButton: true,
            denyButtonText: 'NO',
            denyButtonColor: iconColor,
            confirmButtonText: 'SI',
            confirmButtonColor: iconColor,
            customClass: 'swal-wide-class',
        }).then((response) => {
            if (response.isConfirmed) {
                asyncDeleteAttachmentChatAssistant(id).then((body: any) => {
                    const isSuccessful = body.items !== undefined;
                    Swal.fire({
                        text: isSuccessful
                            ? 'Archivo eliminado con éxito'
                            : 'Error al eliminar el archivo',
                        icon: isSuccessful ? 'success' : 'error',
                        iconColor,
                    });
                    if (isSuccessful) onDelete(id);
                });
            }
        });
    };

    return {
        handleDelete,
    };
};
